import { ApplicationListProps } from 'benefit/applicant/components/applications/applicationList/ApplicationList';
import ListContents from 'benefit/applicant/components/applications/applicationList/listItem/ListContents';
import { ButtonPresetTheme, ButtonVariant } from 'hds-react';
import React, { useState } from 'react';
import Button from 'shared/components/button/Button';

import { $ListActionButtonContainer } from './ApplicationList.sc';
import ListItem from './listItem/ListItem';
import useApplicationList from './useApplicationList';

export interface PaginatedApplicationListProps {
  initialItems: number;
}

type Props = ApplicationListProps & PaginatedApplicationListProps;

const ExpandableApplicationList: React.FC<Props> = ({
  heading,
  status,
  isArchived,
  initialItems,
  orderByOptions,
  noItemsText,
  onListLengthChanged,
  beforeList,
  afterList,
}) => {
  const {
    list,
    shouldShowSkeleton,
    shouldHideList,
    t,
    orderBy,
    setOrderBy,
    hasItems,
  } = useApplicationList({
    status,
    isArchived,
    orderByOptions,
  });

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const showExpand = list.length > initialItems;

  let items =
    list?.map((props) => <ListItem key={props.id} {...props} />) || [];
  if (showExpand && !isExpanded) {
    items = items.slice(0, initialItems);
  }

  return (
    <ListContents
      list={list}
      shouldShowSkeleton={shouldShowSkeleton}
      shouldHideList={shouldHideList}
      t={t}
      orderBy={orderBy}
      setOrderBy={setOrderBy}
      orderByOptions={orderByOptions}
      hasItems={hasItems}
      headingText={heading}
      status={status}
      items={items}
      noItemsText={noItemsText}
      onListLengthChanged={onListLengthChanged}
      beforeList={beforeList}
      afterList={
        <>
          {hasItems && showExpand && (
            <$ListActionButtonContainer>
              <Button
                onClick={() => setIsExpanded(!isExpanded)}
                variant={ButtonVariant.Secondary}
                theme={ButtonPresetTheme.Black}
              >
                {t(
                  isExpanded
                    ? 'common:applications.list.common.contract'
                    : 'common:applications.list.common.expand'
                )}
              </Button>
            </$ListActionButtonContainer>
          )}
          {afterList}
        </>
      }
    />
  );
};

export default ExpandableApplicationList;
